// ... your imports
import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { getDoc, doc, setDoc } from 'firebase/firestore';
import { db, auth } from '../firebase';

export default function LessonReviewPage() {
  const { mockId } = useParams();
  const [readingData, setReadingData] = useState([]);
  const [listeningData, setListeningData] = useState([]);
  const [readingAnswers, setReadingAnswers] = useState([]);
  const [listeningAnswers, setListeningAnswers] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const user = auth.currentUser;

  useEffect(() => {
    const fetchData = async () => {
      if (!user) return;
      setLoading(true);
    
      try {
        const fetchedReading = [], fetchedReadingAnswers = [];
        const fetchedListening = [], fetchedListeningAnswers = [];
    
        for (let i = 1; i <= 2; i++) {
          const res = await fetch(`/data/${mockId}Reading${i}.json`);
          const data = await res.json();
          fetchedReading.push(data);
    
          const answerSnap = await getDoc(
            doc(db, 'users', user.uid, 'mockAnswers', `${mockId}_reading${i}`)
          );
          fetchedReadingAnswers.push(answerSnap.exists() ? answerSnap.data() : {});
        }
    
        for (let i = 1; i <= 5; i++) {
          const res = await fetch(`/data/${mockId}Listening${i}.json`);
          const data = await res.json();
          fetchedListening.push(data);
    
          const answerSnap = await getDoc(
            doc(db, 'users', user.uid, 'mockAnswers', `${mockId}_listening${i}`)
          );
          fetchedListeningAnswers.push(answerSnap.exists() ? answerSnap.data() : {});
        }
    
        // ...rest of your logic here
    

        setReadingData(fetchedReading);
        setReadingAnswers(fetchedReadingAnswers);
        setListeningData(fetchedListening);
        setListeningAnswers(fetchedListeningAnswers);
      } catch (err) {
        console.error('Failed to fetch review data:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [mockId, user]);

  const calculateScore = (questions, answers) => {
    let correct = 0;

    questions.forEach((q) => {
      const userAns = answers[q.id?.toString()];
      const correctAns = q.correctAnswer;

      console.log(" Checking:", q.id);
      console.log("User Answer:", userAns);
      console.log("Expected:", correctAns);

      if (Array.isArray(correctAns)) {
        const normalize = (arr) => arr.map((v) => v.trim()).sort();
        if (Array.isArray(userAns) && JSON.stringify(normalize(userAns)) === JSON.stringify(normalize(correctAns))) {
          correct++;
        }
      } else if (
        typeof correctAns === 'object' &&
        correctAns !== null &&
        userAns?.left &&
        userAns?.right &&
        correctAns?.left &&
        correctAns?.right
      ) {
        const normalize = (arr) => arr.map((v) => v.trim()).sort();
        if (
          JSON.stringify(normalize(userAns.left)) === JSON.stringify(normalize(correctAns.left)) &&
          JSON.stringify(normalize(userAns.right)) === JSON.stringify(normalize(correctAns.right))
        ) {
          correct++;
        }
      } else if (typeof correctAns === 'string' && typeof userAns === 'string') {
        if (userAns.trim() === correctAns.trim()) {
          correct++;
        }
      }
    });

    return correct;
  };

  const readingCorrect = readingData.reduce((sum, d, i) => sum + calculateScore(d.questions, readingAnswers[i]), 0);
  const readingTotal = readingData.reduce((sum, d) => sum + d.questions.length, 0);
  const readingScore = Math.round((readingCorrect / readingTotal) * 30);

  const listeningCorrect = listeningData.reduce((sum, d, i) => sum + calculateScore(d.questions, listeningAnswers[i]), 0);
  const listeningTotal = listeningData.reduce((sum, d) => sum + d.questions.length, 0);
  const listeningScore = Math.round((listeningCorrect / listeningTotal) * 30);

  useEffect(() => {
    const saveScore = async () => {
      if (!user) return;

      const scoreRef = doc(db, "users", user.uid, "mockScores", mockId);
await setDoc(scoreRef, {
  reading: readingScore,
  listening: listeningScore,
  updatedAt: Date.now()
}, { merge: true });

    };

    saveScore();
  }, [readingScore, listeningScore, mockId, user]);

  if (loading) return <p className="p-4">Loading review...</p>;

  return (
    <div className="p-8 max-w-2xl mx-auto text-center">
      <h1 className="text-3xl font-bold mb-6 text-darkblue-800"><span role="img" aria-label="graduation cap">🎓</span> Your TOEFL Practice Results</h1>

      <div className="bg-gray-100 rounded-xl shadow p-6 space-y-4">
        <div className="text-xl font-semibold">
          Reading Score:
          <div className="text-4xl text-blue-700 font-bold">{readingScore} / 30</div>
          <div className="text-sm text-gray-600">{readingCorrect} / {readingTotal} correct</div>
        </div>

        <div className="text-xl font-semibold">
          Listening Score:
          <div className="text-4xl text-green-700 font-bold">{listeningScore} / 30</div>
          <div className="text-sm text-gray-600">{listeningCorrect} / {listeningTotal} correct</div>
        </div>

        <hr className="my-4" />

        <div className="text-xl font-semibold">
          Total Score:
          <div className="text-5xl text-purple-700 font-extrabold">{readingScore + listeningScore} / 60</div>
        </div>
      </div>

      <p className="mt-6 text-gray-500 italic">
      <span role="img" aria-label="check mark">✅</span> Great job completing the first two parts of the mock! You can use your individual reading passage reviews to go deeper, when you complete the mock exam.
      </p>

      <button
        onClick={() => navigate(`/lessonMock/${mockId}/writing/1/intro`)}
        className="mt-8 px-8 py-4 bg-green-600 hover:bg-green-700 text-white text-lg rounded-lg shadow-lg"
      >
        Continue to Writing Tasks <span role="img" aria-label="writing hand">✍️</span>

      </button>

      <p className="mt-6 text-gray-500 italic">
        <strong>WARNING:</strong> Once you click 'Continue to Writing Tasks', the 3-minute timer for the integrated reading will start immediately!
      </p>
    </div>
  );
}
